import * as tslib_1 from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { requireGet, addStatistics } from './require';
import { env } from '@ivy/fts/envInfo/envInfo';
import * as qs from 'qs';
let PayMixin = class PayMixin extends Vue {
    constructor() {
        super(...arguments);
        this.actId = 0;
        this.channelId = null;
        this.slt = null;
        this.actConfig = {};
        this.spu = {};
        this.actIsEnd = true;
        this.spuData = {};
        this.skuData = {};
        this.skus = [];
        this.detailCont = [];
        this.microPages = [];
        this.saleCount = 10000 +
            Math.floor((new Date().getHours() + new Date().getDate() - new Date().getDay()) *
                Math.random() *
                100);
    }
    get endTime() {
        if (!this.actConfig)
            return '';
        if (!this.actConfig.end_time)
            return '';
        let timeArr = this.actConfig.end_time.substring(5, 10).split('-');
        return `${+timeArr[0]}月${timeArr[1] - 1}日`;
    }
    async created() {
        await env.init();
        console.log('env.init');
        if (env.type === 'web')
            return this.$Toast('请在微信中打开');
        if (!(await env.getIsLogin())) {
            return await env.login();
        }
        const { act_id, channel_id, _lottery, slt_channel_id } = this.$route.query;
        // 兼容旧海报
        this.actId = +act_id;
        this.channelId = channel_id;
        this.slt = slt_channel_id;
        if (_lottery) {
            // 埋点-来自大转盘的访问
            await addStatistics({
                activity_id: this.$route.query._sessionStorageInviteActivityId,
                event_type: 'InvitedUsers_SweptCode_Posters_zjs',
                p1: this.$route.query.labelId || this.$route.query.from,
                p2: (await requireGet(`/api/activity/h5Activity/invitation/checkUserType`)).data,
                p5: this.$route.query._cookieDistributorMemId,
            }, !!this.$route.query.labelId);
        }
        if (!this.actId) {
            await this.scanCodeNew();
        }
        await this.getActInfo(this.actId);
        if (this.actId === 43)
            return (this.actIsEnd = false);
        await this.orderSearch();
        typeof this['showNowChooseOrder'] === 'function' &&
            this['showNowChooseOrder'].call();
    }
    async scanCodeNew() {
        const { posterId, source, _cookieDistributorMemId, labelId, } = this.$route.query;
        const { data } = await requireGet(`/api/activity/h5Activity/invitation/getPosterParams?posterId=${posterId}&distributorMemId=${_cookieDistributorMemId}`);
        let userInfo = {};
        if (_cookieDistributorMemId) {
            userInfo = await requireGet(`/api/activity/h5Activity/invitation/checkUserType?distributorMemId=${_cookieDistributorMemId}`);
        }
        let sourceName = source;
        if (labelId) {
            let { data: info } = await requireGet(`/api/activity/h5Activity/invitation/getLabelTagName?labelId=${labelId}`);
            sourceName = info;
        }
        this.actId = +data.id;
        this.channelId = data.default_channel_id;
        this.slt = data.slt_channel_id;
        // 埋点-海报的成功扫码
        await addStatistics({
            activity_id: data.activity_id,
            event_type: 'InvitedUsers_SweptCode_Posters_zjs',
            p1: sourceName,
            p2: userInfo.data,
            p4: data.poster_id,
            p5: _cookieDistributorMemId,
        });
        this.$router.push({
            path: this.actId === 43 ? 'actDetail' : 'putGoodsPop',
            query: {
                act_id: data.id,
                slt: this.slt,
                channel_id: data.default_channel_id,
                posterId: data.poster_id,
                _sessionStorageInviteActivityId: data.activity_id,
                _cookieDistributorMemId: this.$route.query._cookieDistributorMemId,
                source: this.$route.query.source,
                labelId: this.$route.query.labelId,
            },
        });
    }
    async orderSearch() {
        let plat = env.type;
        await env.init();
        if (plat === 'web')
            return this.$Toast('请在微信中打开');
        if (!(await env.getIsLogin())) {
            return await env.login();
        }
        let loginInfo = await env.getInfo();
        // const token = userInfo.logined.token
        const token = env.type === 'wx' ? loginInfo.logined.token : loginInfo.publicParams.token;
        const spuId = this.spu.id;
        if (token && spuId) {
            const { data: registerData } = await requireGet(`/api/m-course/crm/getRegisterBySku?sku_id=${this.spuData.skuInfos[0].id}`);
            if (registerData && registerData.tid) {
                window.location.replace(`${window.location.origin}/act2/invitationMarket/loadingView?${qs.stringify({
                    tid: registerData.tid,
                    channel_id: this.channelId,
                })}`);
            }
            else {
                this.actIsEnd = !this.actConfig;
            }
        }
        else {
            this.actIsEnd = !this.actConfig;
        }
    }
    async getActInfo(actId) {
        const { data } = await requireGet(`/api/activity/crm/put/getActDataForInvitation?id=${actId}`);
        this.actConfig = data;
        if (!this.actConfig) {
            return this.$Toast('活动已结束，请留意其他活动~');
        }
        document.title = this.actConfig.page_title || '常青藤爸爸';
        const { data: spuData } = await requireGet(`/api/goods/shop/search/goods/getSpu?spuId=${this.actConfig.spu_id}&isAllSku=true`);
        this.spuData = spuData;
        this.spu = spuData.spu || spuData.spuInfo;
        this.skus =
            spuData.skuInfos &&
                spuData.skuInfos.sort((a, b) => {
                    if (!a.title.match(/\d/) || !b.title.match(/\d/))
                        return;
                    return a.title.match(/\d/)[0] - b.title.match(/\d/)[0];
                });
        this.goodsType = this.spu.scope;
        this.detailCont = JSON.parse(this.actConfig.detail_cont);
    }
    async toConfirm() {
        if (!this.skuData.id) {
            return this.$Toast('请先选择报名课程');
        }
        this.$router.push({
            path: `/crmPut/orderConfirm`,
            query: {
                channelId: this.channelId,
                spuId: this.spu.id,
                actId: this.actId,
                skuId: this.skuData.id,
                type: this.goodsType,
                slt: this.slt,
            },
        });
    }
    padStart(str, long, padStr) {
        if (str.length < long) {
            for (let index = 0; index < long - str.length; index++) {
                str = padStr + str;
            }
        }
        return str;
    }
    padEnd(str, long, padStr) {
        if (str.length < long) {
            for (let index = 0; index < long - str.length; index++) {
                str += padStr;
            }
        }
        return str;
    }
};
PayMixin = tslib_1.__decorate([
    Component
], PayMixin);
export default PayMixin;
